"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _defaultFilterGroupIcons = _interopRequireDefault(require("../defaultFilterGroupIcons.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var appDefs = window.cccisd.appDefs;

// Simple collapsible component for the FilterSideBar
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      open: !_this.props.isCollapsed
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function (e) {
      e && e.preventDefault();
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getIcon", function () {
      var icon = _this.props.icon;
      if (icon && icon !== 'none') {
        var filterGroupIcons = appDefs.resourceCenters.filterGroupIcons || _defaultFilterGroupIcons["default"];
        return filterGroupIcons.find(function (fg) {
          return fg.id === icon;
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getFilterBarColor", function () {
      var _this$props = _this.props,
        color = _this$props.color,
        icon = _this$props.icon,
        displayOptions = _this$props.displayOptions;
      if (color && icon && icon !== 'none' && color !== '') {
        return {
          backgroundColor: color
        };
      }
      if (displayOptions.portal && displayOptions.portal.filterCollapseColor) {
        return {
          backgroundColor: displayOptions.portal.filterCollapseColor
        };
      }
    });
    return _this;
  }
  _createClass(Component, [{
    key: "render",
    value: function render() {
      var isCollapsible = this.props.collapsible;
      var displayOptions = this.props.displayOptions;
      var icon = this.getIcon();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: isCollapsible ? this.toggle : null,
        style: this.getFilterBarColor(),
        className: _style["default"].header + ' ' + (this.state.open ? _style["default"].open : '') + ' ' + (isCollapsible ? _style["default"].collapsible : '')
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, displayOptions.resources.showFilterGroupIcons && icon && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          margin: '0 0.5em',
          color: '#fff'
        }
      }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
        viewBox: icon.viewBox,
        key: icon.id
      }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: index,
          d: p
        });
      })))), this.props.getTagLabel(this.props.title)), isCollapsible && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, this.state.open ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null))), this.state.open && this.props.children);
    }
  }]);
  return Component;
}(_react["default"].Component);
exports["default"] = Component;
_defineProperty(Component, "propTypes", {
  title: _propTypes["default"].node,
  children: _propTypes["default"].node,
  collapsible: _propTypes["default"].bool,
  displayOptions: _propTypes["default"].object,
  icon: _propTypes["default"].string,
  color: _propTypes["default"].string,
  isCollapsed: _propTypes["default"].bool,
  getTagLabel: _propTypes["default"].func
});